module.exports = __webpack_public_path__ + "media/images/left-c86a99ab8dd04d22b546c4ecab70c87e.svg";